<template>
  <div class="inactive-screen bg-cover">
    <div class="inactive-content">
      <h1>Scan me</h1>
      <img
        :src="'https://clawmachine.nl/qrcode/?s=qr&sf=8&d=' + getUrl()"
        :title="getUrl()"
        width="450"
      />
      <h1>for a</h1>
      <h1>day off</h1>
      <h1>&nbsp;</h1>
      <h1>&nbsp;</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: "InactiveScreen",
  components: {},
  methods: {
    getUrl() {
      return process.env.VUE_APP_GAMEURL;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/custom.scss";
.inactive-screen {
  height: 100dvh;
  position: relative;
  overflow: hidden;
}

.inactive-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: min(100%, 1200px);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 16px;
  padding: 24px;
  box-sizing: border-box;
}

h1 {
  font-size: 10rem;
  line-height: 0.95;
  padding: 0;
  color: $text-color !important;
  font-weight: 500;
  margin: 0;
}
img {
  display: block;
  margin: 0 auto;
  padding: 0;
  max-width: min(450px, 75vw);
  max-height: 40dvh;
  height: auto;
  user-select: none;
  -webkit-user-drag: none;
  pointer-events: auto;
}
/* .outer {
  display: flex;
  align-items: center;
}
.center {
  margin: auto;
  padding: 10px;
} */
.screen {
  /* background: url("~@/assets/home_bg.png") no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  height: 100%; */
  overflow: hidden; /* Hide scrollbars */
}
.home-featured {
  font-weight: 200;
  /* background-color: #e0e493 !important; */
  /* background-image: linear-gradient(
    90deg,
    rgb(171, 224, 255) 0.72%,
    rgb(126, 196, 255) 99.4%
  ); */
  /* background-image: linear-gradient(to top right, purple, violet, orange); */
  background-size: 600% 600%;
  /* -webkit-animation: gradanimate 0.5s ease infinite; */
  /* animation: gradanimate 10s ease infinite; */
}
@-webkit-keyframes gradanimate {
  0% {
    background-position: 2% 0%;
  }
  50% {
    background-position: 99% 100%;
  }
  100% {
    background-position: 2% 0%;
  }
}
@keyframes gradanimate {
  0% {
    background-position: 2% 0%;
  }
  50% {
    background-position: 99% 100%;
  }
  100% {
    background-position: 2% 0%;
  }
}
</style>
